<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-snackbar
        v-model="snackbar"
        xs12
        multi-line
        :timeout="timeout"
        top
        color="orange"
      >
        {{ alertmessage }}
        <v-btn
          color="white"
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-qrcode"
            inline
            title="Site QR Codes"
          >
            <v-col cols="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
            <v-spacer />
            <v-data-table
              :headers="locationHeaders"
              :items="getlocs"
              :items-per-page="50"
              sort-by="status"
              sort-desc
              :search="search"
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  fab
                  small
                  color="deep-purple darken-1"
                  dark
                  @click="generatepdf(item)"
                >
                  <v-icon dark>
                    mdi-file-pdf-box
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.image`]="{ item }">
                <v-dialog
                  transition="dialog-bottom-transition"
                  max-width="600"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="yellow darken-2"
                      small
                      fab
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>
                        mdi-image
                      </v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:default="dialog">
                    <v-card>
                      <v-toolbar
                        color="primary"
                        dark
                      >
                        Right Click to Save Image
                      </v-toolbar>
                      <v-card-text>
                        <div class="text-h2 pa-12">
                          <v-img :src="generateimage(item)" />
                        </div>
                      </v-card-text>
                      <v-card-actions class="justify-end">
                        <v-btn
                          text
                          @click="dialog.value = false"
                        >
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import { jsPDF } from 'jspdf'
  var jrQrcode = require('jr-qrcode')

  export default {

    name: 'Locations',

    data () {
      return {
        search: '',
        loading: false,
        snackbar: false,
        timeout: 5000,
        dialog: false,
        sites: this.$store.getters.loadedSites,
        profiles: this.$store.getters.loadedSiteProfiles,
        totalcount: 0,
        locations: [],
        locationHeaders: [
          {
            sortable: true,
            text: 'Site ID',
            value: 'idnum',
            width: 300
          },
          {
            sortable: false,
            text: 'QR PDF',
            value: 'action',
            align: 'center'
          },
          {
            sortable: false,
            text: 'QR Image',
            value: 'image',
            align: 'center'
          },
          {
            sortable: false,
            text: 'Safe ID',
            value: 'safeid'
          },
          {
            sortable: false,
            text: 'Site Key',
            value: 'sitekey'
          },

        ],
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        alertmessage: ''
      }
    },
    computed: {
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      getmessagedata () {
        let data = this.$store.getters.getSystemData
        let messagecount = data.map(element => element.totalmessages)
        this.totalcount = messagecount.reduce((acc, val) => acc + val, 0)

        let disconects = data.map(element => element.mqtt_disco)
        let recon = data.map(element => element.mqtt_recon)
        let times = data.map(element => element.timestamp)
        this.chartOptionsMessages.xaxis.categories = times
        /* eslint-disable no-return-assign */

        return this.perfdata = [{
          name: 'Messages',
          data: messagecount
        }, {
          name: 'Disconnects',
          data: disconects
        }, {
          name: 'Reconnects',
          data: recon
        }]
      },
      getsystemdata () {
        let data = this.$store.getters.getSystemData
        let times = data.map(element => element.timestamp)
        this.chartOptions.xaxis.categories = times
        let pings = data.map(element => element.msg_count_ping)
        let cashheld = data.map(element => element.msg_count_cashheld)
        let citmessaaages = data.map(element => element.msg_count_cit)
        let deposits = data.map(element => element.msg_count_deposit)
        let manualdeposits = data.map(element => element.msg_count_manualdeposit)
        let rejections = data.map(element => element.msg_count_rejected)
        let notein = data.map(element => element.msg_count_notein)
        let other = data.map(element => element.totalmessages - (element.msg_count_ping + element.msg_count_notein + element.msg_count_rejected + element.msg_count_manualdeposit + element.msg_count_deposit + element.msg_count_cit + element.msg_count_cashheld))

        return this.perfdata = [{
          name: 'Pings',
          data: pings
        }, {
          name: 'Cash Held',
          data: cashheld
        }, {
          name: 'CIT Events',
          data: citmessaaages
        }, {
          name: 'Deposits',
          data: deposits
        }, {
          name: 'Manual Deposits',
          data: manualdeposits
        }, {
          name: 'Rejections',
          data: rejections
        }, {
          name: 'Note In',
          data: notein
        }, {
          name: 'Other',
          data: other
        }]
      },
      getlocs () {
        this.locations = []
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          console.log(name)
          let sitekey = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            name = loc.sitename
            sitekey = value.sitekey
          }
          if (value.siteunitsprofile) {
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            let shop = {
              idnum: key,
              sitekey: sitekey,
              safeid: safeid,
            }
            this.locations.push(shop)
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true

      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadUserGroups')
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadheartbeats')
      this.$store.dispatch('loadsystemdata')
      // let j = Object.keys(loadedprofiles)
      // let units = loadedprofiles[j[0]].siteunitsprofile
    },
    beforeDestroy () {
      // this.$store.dispatch('resetsafetransactions')
    },
    timers: {
      log: { time: 5000, autostart: true, repeat: true }
    },
    methods: {
      log () {
        // this.$store.dispatch('loadheartbeats')
        // this.$store.dispatch('loadsafes')
        // console.log(this.$store.getters.getheartbeatvalues)
      },
      generatepdf (item) {
        /* eslint-disable new-cap */

        const doc = new jsPDF()
        console.log(item)
        doc.setFontSize(22)
        doc.text('Paythings SmartSafe', doc.internal.pageSize.getWidth() / 2, 20, { align: 'center' })
        doc.text('Live Smart Safe Services/troubleshooting operator', doc.internal.pageSize.getWidth() / 2, 40, { align: 'center' })
        doc.text('914-246-2688', doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' })
        doc.text(item.idnum, doc.internal.pageSize.getWidth() / 2, 60, { align: 'center' })
        let imgBase64 = jrQrcode.getQrBase64('https://paythings-virtual-logbook.firebaseapp.com/logbook/' + item.sitekey)
        doc.addImage(imgBase64, 'JPEG', 50, 80, 120, 120)

        doc.save(item.idnum + '.pdf')
        this.alertmessage = 'Downloading QR code for ' + item.idnum
        this.snackbar = true
      },
      generateimage (item) {
        let imgBase64 = jrQrcode.getQrBase64('https://paythings-virtual-logbook.firebaseapp.com/logbook/' + item.sitekey)
        return imgBase64
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
